// "Remember Me" (persistent login) is rolled out on Local, Test, Staging and Production (USA, Canada).
// Remove a host from the list below to fall back to the previous login behaviour there.
const REMEMBER_ME_HOSTS = [
	'fleet.roscolive.com',
	'canada.roscolive.com',
	'test.roscolive.com',
	'staging.roscolive.com',
	'localhost',
	'127.0.0.1',
];

export const isRememberMeEnabled = () => REMEMBER_ME_HOSTS.includes(window.location.hostname);
